import { getPlan } from '../stripe-config'

// PLANS dérivé de la source de vérité unique (src/stripe-config.ts).
// Ne PAS dupliquer les price IDs / prix ici — tout vit dans stripe-config.
export const PLANS = {
  BASIC: getPlan('basic'),
  PRO: getPlan('pro'),
  PREMIUM: getPlan('premium'),
} as const

export const AFFILIATE = {
  COMMISSION_RATE: 0.3,
  COOKIE_DURATION: 90,
  MIN_PAYOUT: 50,
} as const

export const CONTACT = {
  EMAIL: 'support@trackmarkete.com',
  DISCORD: 'https://discord.gg/trading',
  TWITTER: 'https://twitter.com/trackmarkete',
} as const

export const APP_URL = 'https://trackmarkete.com'
export const JOURNAL_URL = 'https://journalemt.netlify.app'
